import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, useLocation, withRouter } from "react-router";
import { ApplicationState } from "../../../store";
import {
  deleteDistrict,
  getDistrictLicenses,
  selectDistrict,
  setShowDistrictLicenseModal,
} from "../../../store/superuser/actions";
import { push } from "connected-react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faPen,
  faPlusCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Release_Notes, SuperuserState } from "../../../store/superuser/types";

import LoadingIndicator from "../../common/onboarding/LoadingIndicator";
import { formatDate } from "../../utils/DateTimeUtils";
import useUserRole from "../../../utils/hooks/useUserRole";
import DOMPurify from "dompurify";

type MatchParams = {
  releaseNoteId?: string;
  releaseNoteYear?: string;
};

type Props = RouteComponentProps<MatchParams>;

// The description field can come back HTML-entity-encoded (e.g. "&lt;p&gt;...&lt;/p&gt;")
// instead of raw HTML. Decoding it once first ensures the real tags are restored
// before sanitization/rendering, rather than being displayed as literal text.
const decodeHtmlEntities = (value: string) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};
const HtmlToText = ({ htmlString }: { htmlString: string }) => {
  const sanitizedHtml = useMemo(() => {
    const decoded = decodeHtmlEntities(htmlString);
    return DOMPurify.sanitize(decoded);
  }, [htmlString]);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

const ReleaseNotesDetail: FunctionComponent<Props> = ({
  match: {
    params: { releaseNoteId, releaseNoteYear },
  },
}) => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const { isDistrictOwner } = useUserRole();
  const releaseNotes = useSelector((s: ApplicationState) => s.superuser.releaseNotes);
  
  const handleBack = () => {
    dispatch(push(`${isDistrictOwner ? '/district' : ''}/release-notes?year=${params.get('year')}`));
  };

  const releaseNote  = useMemo(() => {
    if(releaseNotes.length) {
      const publishedReleaseNotes: Release_Notes[] = releaseNotes.filter((release) => release.is_published);
      if(publishedReleaseNotes.length) {
        return publishedReleaseNotes.find((prn) => prn.id == releaseNoteId);
      }
    }
    return undefined;
  },[releaseNoteId])

  return (
      <div className="onboardingContainer">
        <div className="w-100 d-flex justify-content-between">
          <button
            className="blueBtnSm"
            onClick={handleBack}
          >
            <FontAwesomeIcon icon={faArrowLeft} style={{ color: "white" }} />{" "}
            Back
          </button>
        </div>
        {releaseNote ? 
          <div className="jumbotron">
          <h1>{releaseNote.title}</h1>
          <hr className="my-4"/>
          <p><HtmlToText htmlString={releaseNote.description} /></p>
        </div>
        : ''}
      </div>
    )
};

export default withRouter(ReleaseNotesDetail);
